import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		minWidth: 0,
	},
	label: {
		paddingTop: "19px",
		width: "20px",
		flexShrink: 0,
	},
	container: {
		...shorthands.padding(tokens.spacingHorizontalM, tokens.spacingVerticalXXS),
		minWidth: 0,
	},
	input: {
		height: "32px",
		width: "100%",
		...shorthands.border("none"),
		backgroundColor: tokens.colorNeutralBackground1,
		color: tokens.colorNeutralForeground1,
		"&:focus-visible, &:hover": {
			...shorthands.outline(0),
		},
	},
	inputClearButton: {
		paddingRight: "32px",
	},
	inputWrapper: {
		width: "100%",
		position: "relative",
	},
	clearButton: {
		position: "absolute",
		right: "2px",
		top: "50%",
		transform: "translateY(-50%)",
		background: "none",
		border: "none",
		cursor: "pointer",
	},
});
